<template>
    <div class="matchmaker-chart-container">
        <span class="chart-title">{{title}}</span>
        <button class="btn graph-clear" v-if="isGraphFiltered" @click.prevent="clearGraphFilters($event)">RESET</button>
        <div :id="refId" ref="eChartsDOM" class="chart"></div>
        <div v-show="loadingGraphFilter" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
    </div>
</template>
<script>
 import * as echarts from 'echarts';
export default {
    name: 'chart',
    props: [
        'refId',
        'graphData',
        'color',
        'title',
        'filteredValues',
        'filterField'
    ],
    data () {
        return {
            eChart: null,
            animate: true,
            resizeTimeout: null,
            exportChart: null,
            exportImageWidth: 1024,
            exportImageHeight: 768,
            chartId: null,
            chartOptions: copyData(sharedSpecs.eCharts),
            loadingGraphFilter: false
        };
    },
    computed: {
        isGraphFiltered: function () {
            return this.filteredValues.length !== 0;
        }
    },
    mounted () {
        this.loadingGraphFilter = true;
        this.eChartsInit();
    },
    watch: {
        graphData: function () {
            this.eChartsBuild();
        }
    },
    methods: {
        eChartsInit () {
            let processClick = (event, name) => {
                    var facetsComp = this.$parent.$parent.$refs.facets.$refs.facets,
                        index = facetsComp.facetCriteria[this.filterField].indexOf(name);

                    this.loadingGraphFilter = true;

                    if (index === -1) {
                        facetsComp.facetCriteria[this.filterField].push(name);
                    } else {
                        facetsComp.facetCriteria[this.filterField] = [...facetsComp.facetCriteria[this.filterField].splice(0, index), ...facetsComp.facetCriteria[this.filterField].splice(index + 1, facetsComp.facetCriteria[this.filterField].length)];
                    }

                    facetsComp.checkCheck({ name: this.filterField }, { value: name });
                };

            this.eChart = echarts.init(this.$refs.eChartsDOM);

            this.eChart.on('click', (params) => {
                if (params && params.name) {
                    processClick(params.event.event, params.name);
                }
            });

            window.addEventListener('resize', () => {
                this.resizeChart();
            });

            if (this.graphData) {
                this.eChartsBuild();
            }

            this.init = true;
        },
        eChartsBuild () {
            var textVal = 0,
                nameGap = 0,
                textFormat = 'normal 15px Roboto',
                series;

            this.loadingGraphFilter = false;

            series = this.graphData.map(el => {
                return {
                    value: el.count,
                    itemStyle: {
                        color: this.isGraphFiltered && this.filteredValues.indexOf(el.value) === -1 ? '#757575' : this.color,
                        opacity: this.isGraphFiltered && this.filteredValues.indexOf(el.value) === -1 ? 0.25 : 1
                    }
                };
            });

            this.chartOptions = Object.assign({}, this.chartOptions, {
                grid: {
                    top: 10,
                    right: 5,
                    bottom: 52,
                    left: 65
                },
                tooltip: {
                    confine: true,
                    trigger: 'item',
                    // triggerOn: 'click',
                    axisPointer: {
                        shadowStyle: {
                            color: 'rgba(8, 130, 220, 0.1)'
                        },
                        type: 'shadow',
                        z: '0',
                    },
                    formatter: (params) => {
                        let toolTipStr = '';

                        this.tooltipHoverIC = params.name;

                        if (this.$parent.$parent.currentView === 'matchmaker-projects') {
                            toolTipStr = '<strong>Projects</strong><br>';
                        } else {
                            toolTipStr = '<strong>Program Officials</strong><br>';
                        }
                        return  toolTipStr + params.marker + params.name + ': ' + window.addCommas(params.value);
                    }
                },
                xAxis: {
                    type: 'category',
                    nameLocation: 'center',
                    axisLabel: {
                        rotate: 90
                    },
                    data: this.graphData.map(el => el.value),
                },
                yAxis: {
                    type: 'value',
                    name: (this.$parent.$parent.currentView === 'matchmaker-projects') ? 'Projects' : 'Program Officials',
                    nameLocation: 'center',
                    nameTextStyle: {
                        fontWeight: 'bold',
                        fontFamily: 'sans-serif'
                    },
                    splitNumber: 4,
                    axisLabel: {
                        formatter: (value) => {
                            if (value > textVal) {
                                textVal = value;
                                nameGap = copyData(Math.ceil(window.getTextWidth(this.formatter(textVal, true), textFormat)));
                                setTimeout( () => {
                                    this.chartOptions.yAxis.nameGap = nameGap + 10;
                                    this.eChart.setOption(this.chartOptions, true);
                                }, 1);
                            }
                            return this.formatter(value, 'y');
                        }
                    },
                    nameGap: nameGap
                },
                series: [{
                    data: series,
                    type: 'bar',
                    barMaxWidth: 30
                }]
            });

            this.loading = false;

            this.eChart.setOption(this.chartOptions);
        },
        formatter (value, axis) {
            return window.filters.addCommas(value);
        },
        resizeChart () {
            if (this.animate) {
                this.eChart.setOption({
                    animation: false
                });
            }

            try {
                this.eChart.resize();
            } catch (er) {
                
            }

            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            this.resizeTimeout = setTimeout(() => {
                this.animate = true;

                this.eChart.setOption({
                    animation: true
                });
            }, 300);
        },
        clearGraphFilters ($event) {
            // This selector feels insane
            this.$parent.$parent.$refs.facets.$refs.facets.clearSelections(this.filterField, $event);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/scss/variables.scss';

.chart-title {
    padding-left: 64px; // Align chart title with y-axis
    font-size: 14px;
    font-weight: bold;
}

.matchmaker-chart-container {
    width: calc((1 / 3) * 100%);
    padding: 10px;
    font-size: 14px;
    display: inline-block;
}

.chart {
    height: 170px;
    width: 100%;
    text-align: left;
}

button.graph-clear {
    background-color: #fff;
    color: $red;
    font-size: 12px;
    font-weight: 700;
    margin: 0 2px 0 0;
    vertical-align: middle;
    padding: 1px 15px;
    text-transform: uppercase;
    position: relative;
    z-index: 200;
    // display: inline-block;
    min-width: 10px;
    white-space: nowrap;
    cursor: pointer;
    background-image: none;
    border: 1px solid $grey-light-border;
    border-radius: 12px;
    text-align: center;
    width: auto;
    float: right;

    &:hover,
    &:focus {
        background-color: $red;
        color: #fff;
        border: 1px solid transparent;
    }
}

.chartDataTable .matchmaker-chart-container.loading {
    background-color: transparent;
    opacity: 1;
    top: 0;
}
.loading {
    top: 0;
    opacity: 0.9;
    width: calc((1 / 3) * 100%);
    .loader {
        top: calc((100% - 10em) / 2);
        display: none;
    }
}
</style>

